import { AuthPermissions } from "@eventsquare/uikit";

export const authPermissions: AuthPermissions = {
  organisator: ["pos"],
  manager: ["pos"],
  support: ["pos"],
  viewer: [],
};
